module.exports = __webpack_public_path__ + "images/marketing/peeps/jp_werlin.jpg";